import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-ai-trip',
  templateUrl: './ai-trip.component.html',
  styleUrls: ['./ai-trip.component.css']
})
export class AiTripComponent implements OnInit {

  constructor(private router: Router
    , private meta: Meta, private title: Title
  ) { }

  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
  }
  metaTagAdd() {
    this.title.setTitle('AI Powered Trip Planner | My Yatra 360');

    this.meta.updateTag({
      name: 'description',
      content: 'Let our smart AI assistant craft your perfect travel itinerary — from hidden gems to top attractions. Plan your dream trip effortlessly with My Yatra 360.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'AI Trip Planner Pilgrimage Tours'
    });
  }
  aitripfirstdRedirect() {
    this.router.navigate(['ai-trip-first']);
  }
}
